import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { money } from "@/lib/format";

const COMPANY = [
  ["company_name", "Ragione sociale"], ["vat_number", "Partita IVA"], ["tax_code", "Codice fiscale"],
  ["registration_number", "N. registro imprese"], ["contact_name", "Referente"], ["phone", "Telefono"],
  ["email", "Email"], ["address", "Indirizzo"], ["city", "Città"], ["postal_code", "CAP"], ["country", "Paese"],
];
const BANK = [
  ["bank_name", "Nome banca"], ["account_holder", "Intestatario conto"], ["iban", "IBAN"],
  ["swift", "SWIFT/BIC"], ["bank_country", "Paese banca"],
];
const PAY_TEXT = [
  ["payment_method", "Metodo di pagamento preferito"], ["payment_terms", "Termini di pagamento"],
  ["commission_agreement", "Accordo commissioni"],
];
const PAY_NUM = [
  ["internal_rate", "Tariffa interna %"], ["commission_pct", "Commissione %"],
  ["total_earned", "Totale maturato"], ["total_paid", "Totale pagato"], ["total_pending", "Totale da pagare"],
];

function Field({ label, value, onChange, type = "text" }) {
  return (
    <div className="space-y-1.5">
      <Label>{label}</Label>
      <Input type={type} value={value ?? ""} onChange={(e) => onChange(type === "number" ? (e.target.value === "" ? null : Number(e.target.value)) : e.target.value)} data-testid={`partner-field`} />
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div>
      <h4 className="font-display text-base font-semibold text-slate-900 mb-3">{title}</h4>
      <div className="grid sm:grid-cols-2 gap-3">{children}</div>
    </div>
  );
}

export function PartnerFields({ form, setForm, adminMode = true }) {
  const set = (k, v) => setForm({ ...form, [k]: v });
  return (
    <div className="space-y-6">
      <Section title="Dati azienda">
        {COMPANY.map(([k, l]) => <Field key={k} label={l} value={form[k]} onChange={(v) => set(k, v)} />)}
      </Section>

      <Section title="Coordinate bancarie">
        {BANK.map(([k, l]) => <Field key={k} label={l} value={form[k]} onChange={(v) => set(k, v)} />)}
      </Section>

      {adminMode ? (
        <div>
          <h4 className="font-display text-base font-semibold text-slate-900 mb-3">Dettagli pagamento</h4>
          <div className="grid sm:grid-cols-2 gap-3">
            {PAY_TEXT.map(([k, l]) => <Field key={k} label={l} value={form[k]} onChange={(v) => set(k, v)} />)}
            {PAY_NUM.map(([k, l]) => <Field key={k} label={l} type="number" value={form[k]} onChange={(v) => set(k, v)} />)}
            <div className="space-y-1.5">
              <Label>Stato pagamento</Label>
              <Select value={form.payment_status || "pending"} onValueChange={(v) => set("payment_status", v)}>
                <SelectTrigger data-testid="partner-payment-status"><SelectValue /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="pending">In attesa</SelectItem>
                  <SelectItem value="partial">Parziale</SelectItem>
                  <SelectItem value="paid">Pagato</SelectItem>
                  <SelectItem value="overdue">Scaduto</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <Field label="Data ultimo pagamento" type="text" value={form.last_payment_date} onChange={(v) => set("last_payment_date", v)} />
            <div className="flex items-center gap-2 pt-6"><Switch checked={form.active !== false} onCheckedChange={(v) => set("active", v)} /><span className="text-sm text-slate-500">Attivo</span></div>
          </div>
        </div>
      ) : (
        <div>
          <h4 className="font-display text-base font-semibold text-slate-900 mb-3">Riepilogo pagamenti</h4>
          <p className="text-xs text-slate-400 mb-3">Questi dati sono gestiti dall'amministrazione.</p>
          <div className="grid sm:grid-cols-2 gap-3 text-sm">
            <ReadOnly label="Stato pagamento" value={form.payment_status} />
            <ReadOnly label="Metodo" value={form.payment_method} />
            <ReadOnly label="Termini" value={form.payment_terms} />
            <ReadOnly label="Totale maturato" value={money(form.total_earned)} />
            <ReadOnly label="Totale pagato" value={money(form.total_paid)} />
            <ReadOnly label="Totale da pagare" value={money(form.total_pending)} />
            <ReadOnly label="Ultimo pagamento" value={form.last_payment_date} />
          </div>
        </div>
      )}
    </div>
  );
}

function ReadOnly({ label, value }) {
  return (
    <div className="rounded-lg border border-slate-200 px-3 py-2">
      <div className="text-xs uppercase tracking-wider text-slate-400">{label}</div>
      <div className="text-slate-800 font-medium">{value || "—"}</div>
    </div>
  );
}
